import { put, call } from 'redux-saga/effects';
import { formatMessage } from 'devextreme/localization';
import * as actions from '../actions/responsiblePerson';
import { get, del, post } from '../../utils/api';
import { modalErrorOpen } from '../actions/modalError';

export function* getResponsiblePersonsOnStock({ payload }) {
  try {
    const response = yield call(get, `/plant/signer/list?plantId=${payload.plantId}`);
    yield put(actions.getResponsiblePersonsOnStockSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.getResponsiblePersonsOnStockFail());
  }
}

export function* delResponsiblePersonOnStock({ payload }) {
  try {
    yield call(del, `/plant/signer/${payload.plantSignerId}`);
    yield put(actions.delResponsiblePersonOnStockSuccess());
    yield put(actions.getResponsiblePersonsOnStock({ plantId: payload.plantId }));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.delResponsiblePersonOnStockFail());
  }
}

export function* getListResponsiblePersons({ payload }) {
  try {
    const response = yield call(get, `/signer/list?plantId=${payload.plantId}`);
    yield put(actions.getListResponsiblePersonsSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.getListResponsiblePersonsFail());
  }
}
export function* addResponsiblePerson({ payload }) {
  try {
    yield call(post, `/signer/add?plantId=${payload.plantId}&fio=${encodeURI(payload.fio)}`);
    yield put(actions.addResponsiblePersonSuccess());
    yield put(actions.getListResponsiblePersons({ plantId: payload.plantId }));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.addResponsiblePersonFail());
  }
}
export function* delResponsiblePerson({ payload }) {
  try {
    yield call(del, `/signer/${payload.id}?plantId=${payload.plantId}`);
    yield put(actions.delResponsiblePersonSuccess());
    yield put(actions.getListResponsiblePersons({ plantId: payload.plantId }));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.delResponsiblePersonFail());
  }
}

export function* addResponsiblePersonOnStock({ payload }) {
  try {
    yield call(post, '/plant/signer/add', payload);
    yield put(actions.getResponsiblePersonsOnStock({ plantId: payload.plantId }));
    yield put(actions.addResponsiblePersonOnStockSuccess());
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'info',
        title: formatMessage('textError').warning
      })
    );
    yield put(actions.addResponsiblePersonOnStockFail());
  }
}
